import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./approval.css";
import ApproverService from "../../services/approver.service";
import Header from "../../components/header/Header";
import Preloader from "../../components/preloader/Preloader";
import Success from "../../components/success/Success";
import { baseURL } from "../../common/constants";
import DocumentModal from "../../components/DocumentModal";
import { Document, Page, pdfjs } from "react-pdf";
import AmountForm from "./AmountForm";
import TenorForm from "./TenorForm";
import toast from "react-hot-toast";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const Approval = () => {
	const { projectID } = useParams();
	const [fetching, setFetching] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);
	const [isApproved, setIsApproved] = useState(false);
	const [projectData, setProjectData] = useState({});
	const [reviewerData, setReviewerData] = useState({});
	const [initiatorData, setInitiatorData] = useState({});
	const [showImage, setShowImage] = useState(false);
	const [viewBidDoc, setViewBidDoc] = useState(false);
	const [viewExecDoc, setViewExecDoc] = useState(false);
	const [viewOfferDoc, setViewOfferDoc] = useState(false);
	const [viewVerifyDoc, setViewVerifyDoc] = useState(false);
	const [showAmountForm, setShowAmountForm] = useState(false);
	const [showTenorForm, setShowTenorForm] = useState(false);

	const getProject = async (id) => {
		setFetching(true);
		let res = await ApproverService.approverProject(id);
		console.log(res);
		const data = res.data.project;
		const _data = res.data.reviewer;
		const _data_ = res.data.initiator;
		setProjectData(data);
		setReviewerData(_data);
		setInitiatorData(_data_);
		setFetching(false);
	};

	useEffect(() => {
		getProject(projectID);
	}, [projectID]);

	const [numPages, setNumPages] = useState(null);
	const onDocumentLoadSuccess = ({ numPages }) => {
		setNumPages(numPages);
	};

	const handleStatus = async (e) => {
		e.preventDefault();
		setIsDisabled(true);
		try {
			const _status = { reviewerRejected: true };
			let res = await ApproverService.updateProjectStatus(
				projectData._id,
				_status,
			);
			if (res.data.success === true) {
				toast.success(res.data.msg);
				setIsDisabled(false);
			}
		} catch (err) {
			toast.error(err);
		}
	};

	const handleApprove = async (e) => {
		e.preventDefault();
		try {
			const _approve = { approved: true };
			let res = await ApproverService.updateProjectReview(
				projectData._id,
				_approve,
			);
			if (res.data.success === true) {
				toast.success(res.data.msg);
				setIsDisabled(false);
				setIsApproved(true);
				setInterval(() => {
					setIsApproved(false);
				}, 10000);
			}
		} catch (err) {
			toast.error(err);
		}
	};

	const checkProjectStage = (r, a) => {
		if (r === false && a === false) {
			return "PENDING REVIEW";
		} else if (r === true && a === false) {
			return "PENDING APPROVAL";
		} else if (r === true && a === true) {
			return "APPROVED";
		} else {
			return "PENDING REVIEW";
		}
	};

	return (
		<div className="action__page">
			<Header />
			<div className="approval__page__heading">APPROVAL DESK</div>
			<div className="approval">
				<div className="approval__card-wrapper">
					<div className="approval__card-container">
						<div className="approval__card--header">PROJECT DETAILS</div>
						<div className="approval__card">
							<div className="approval__card__upper">
								<div className="approval__image-wrapper first__card__left">
									<img
										src={`${baseURL}/files/image/${projectData.image}`}
										alt="project"
									/>
								</div>
								<div className="approval__upper__content">
									<div
										className="upper-heading inner-heading"
										style={{ color: "#901919" }}
									>
										{projectData.title}
									</div>
									<p>{projectData.purpose}</p>
								</div>
							</div>
							<div className="approval__card__middle location">
								<div className="location-key">LOCATION:</div>
								<div className="location-value">{projectData.location}</div>
								<div className="location-key">PROJECT CONTRACTOR:</div>
								<div className="location-value">{projectData.companyName}</div>
							</div>
							<button
								onClick={() => setShowImage(true)}
								className="approval__card-submit__button"
							>
								View
							</button>
						</div>
					</div>

					<div className="approval__card-container">
						<div className="approval__card--header">PROJECT BATCHING</div>
						<div className="approval__card padded-card">
							<div className="approval__project">
								<div style={{ color: "#901919" }}>PROJECT TENOR:</div>
								<div>{projectData.tenor} YEARS</div>
							</div>
							<div className="approval__project">
								<div style={{ color: "#901919" }}>PROJECT UNIQUE CODE:</div>
								<div>{projectData.uniqueCode}</div>
							</div>
							<div className="approval__project">
								<div style={{ color: "#901919" }}>CLASSIFICATION CODE GENERATED:</div>
								<div>{projectData.classificationCode}</div>
							</div>
							<div className="approval__project">
								<div style={{ color: "#901919" }}>PROJECT STAGE:</div>
								<div>
									{checkProjectStage(projectData.reviewed, projectData.approved)}
								</div>
							</div>
							<button
								onClick={() => setShowTenorForm(true)}
								className="approval__card-submit__button"
							>
								Review
							</button>
						</div>
						<TenorForm
							projectData={projectData}
							show={showTenorForm}
							onHide={() => setShowTenorForm(false)}
						/>
					</div>

					<div className="approval__card-container">
						<div className="approval__card--header">PROJECT AMOUNT</div>
						<div className="approval__card" style={{ position: "relative" }}>
							<div className="approval__project">
								<div style={{ color: "#901919" }}>PARTIAL PAYMENT:</div>
								<div>
									&#x20A6;{" "}
									{projectData && (
										<span>
											{projectData.partialAmount === undefined || null || ""
												? ""
												: projectData.partialAmount
														.toString()
														.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
										</span>
									)}
								</div>
							</div>
							<div className="approval__project">
								<div style={{ color: "#901919" }}>FULL PAYMENT:</div>
								<div>
									&#x20A6;{" "}
									{projectData && (
										<span>
											{projectData.fullAmount === undefined || null || ""
												? ""
												: projectData.fullAmount
														.toString()
														.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
										</span>
									)}
								</div>
							</div>
							<div className="approval__project">
								<div style={{ color: "#901919" }}>MODE OF PAYMENT:</div>
								<div className="inner-heading">
									{projectData.preferredModeOFPayment}
								</div>
							</div>
							<div className="approval__project">
								<div style={{ color: "#901919" }}>ACCOUNT TO BE PAID INTO:</div>
								<div className="inner-heading">{projectData.titleOfAccount}</div>
							</div>
							<div className="approval__project">
								<div style={{ color: "#901919" }}>BANK NAME:</div>
								<div className="inner-heading">{projectData.bankName}</div>
							</div>
							<div className="approval__project">
								<div style={{ color: "#901919" }}>BANK ACCOUNT NUMBER:</div>
								<div className="inner-heading">{projectData.bankAccountNumber}</div>
							</div>
							<button
								onClick={() => setShowAmountForm(true)}
								className="approval__card-view__button"
								style={{ position: "absolute", right: "20px", bottom: "8px" }}
							>
								Review
							</button>
						</div>
						<AmountForm
							projectData={projectData}
							show={showAmountForm}
							onHide={() => setShowAmountForm(false)}
						/>
					</div>
					<div className="approval__card-container">
						<div className="approval__card--header">PROJECT DOCUMENTATION</div>
						<div className="approval__card padded-card">
							<div className="approval__project">
								<div style={{ color: "#901919" }}>DOCUMENT 1:</div>
								<div className="approval__card-cta">
									UPLOADED{" "}
									<button
										className="approval__card-view__button"
										onClick={() => setViewBidDoc(true)}
									>
										View
									</button>
								</div>
							</div>
							<div className="approval__project">
								<div style={{ color: "#901919" }}>DOCUMENT 2:</div>
								<div className="approval__card-cta">
									UPLOADED{" "}
									<button
										className="approval__card-view__button"
										onClick={() => setViewExecDoc(true)}
									>
										View
									</button>
								</div>
							</div>
							<div className="approval__project">
								<div style={{ color: "#901919" }}>DOCUMENT 3:</div>
								<div className="approval__card-cta">
									UPLOADED{" "}
									<button
										className="approval__card-view__button"
										onClick={() => setViewOfferDoc(true)}
									>
										View
									</button>
								</div>
							</div>
							<div className="approval__project">
								<div style={{ color: "#901919" }}>DOCUMENT 4:</div>
								<div className="approval__card-cta">
									UPLOADED{" "}
									<button
										className="approval__card-view__button"
										onClick={() => setViewVerifyDoc(true)}
									>
										View
									</button>
								</div>
							</div>
						</div>
					</div>

					<p className="approval__note__info">N.B. KINDLY REVIEW BEFORE APPROVING</p>
				</div>
				<div className="action-btns">
					<button onClick={handleStatus} disabled={isDisabled}>
						REJECT
					</button>
					<button onClick={handleApprove} disabled={isDisabled}>
						APPROVE
					</button>
				</div>
				{initiatorData && (
					<p className="approval__initiator">
						INITIATED BY:{" "}
						{initiatorData.firstname === undefined ||
						initiatorData.firstname === null ||
						!initiatorData
							? ""
							: initiatorData.firstname.toUpperCase()}{" "}
						{initiatorData.lastname === undefined ||
						initiatorData.lastname === null ||
						!initiatorData
							? ""
							: initiatorData.lastname.toUpperCase()}{" "}
						{initiatorData.staffnum === undefined ||
						initiatorData.staffnum === null ||
						!initiatorData
							? ""
							: initiatorData.staffnum.toUpperCase()}
					</p>
				)}
				{reviewerData ? (
					<p className="approval__reviewer">
						REVIEWED BY:{" "}
						{reviewerData.firstname === undefined ||
						reviewerData.firstname === null ||
						!reviewerData
							? ""
							: reviewerData.firstname.toUpperCase()}{" "}
						{reviewerData.lastname === undefined ||
						reviewerData.lastname === null ||
						!reviewerData
							? ""
							: reviewerData.lastname.toUpperCase()}{" "}
						{reviewerData.staffnum === undefined ||
						reviewerData.staffnum === null ||
						!reviewerData
							? ""
							: reviewerData.staffnum.toUpperCase()}
					</p>
				) : (
					<p className="approval__reviewer">REVIEWED BY: ___ ___ ___</p>
				)}
			</div>
			<DocumentModal
				heading={"Project Image"}
				show={showImage}
				onHide={() => setShowImage(false)}
			>
				<img src={`${baseURL}/files/image/${projectData.image}`} alt="project" />
			</DocumentModal>
			<DocumentModal
				heading={"Bid Document"}
				show={viewBidDoc}
				onHide={() => setViewBidDoc(false)}
			>
				<Document
					file={`${baseURL}/files/file/${projectData.bidDocument}`}
					onLoadSuccess={onDocumentLoadSuccess}
				>
					{" "}
					{Array.from(new Array(numPages), (el, index) => (
						<Page key={`page_${index + 1}`} pageNumber={index + 1} />
					))}{" "}
				</Document>
			</DocumentModal>
			<DocumentModal
				heading={"Executive Summary Document"}
				show={viewExecDoc}
				onHide={() => setViewExecDoc(false)}
			>
				<Document
					file={`${baseURL}/files/file/${projectData.executiveSummary}`}
					onLoadSuccess={onDocumentLoadSuccess}
				>
					{" "}
					{Array.from(new Array(numPages), (el, index) => (
						<Page key={`page_${index + 1}`} pageNumber={index + 1} />
					))}{" "}
				</Document>
			</DocumentModal>
			<DocumentModal
				heading={"Offer Document"}
				show={viewOfferDoc}
				onHide={() => setViewOfferDoc(false)}
			>
				<Document
					file={`${baseURL}/files/file/${projectData.offerDocument}`}
					onLoadSuccess={onDocumentLoadSuccess}
				>
					{" "}
					{Array.from(new Array(numPages), (el, index) => (
						<Page key={`page_${index + 1}`} pageNumber={index + 1} />
					))}{" "}
				</Document>
			</DocumentModal>
			<DocumentModal
				heading={"Verification Document"}
				show={viewVerifyDoc}
				onHide={() => setViewVerifyDoc(false)}
			>
				<Document
					file={`${baseURL}/files/file/${projectData.verificationDocument}`}
					onLoadSuccess={onDocumentLoadSuccess}
				>
					{" "}
					{Array.from(new Array(numPages), (el, index) => (
						<Page key={`page_${index + 1}`} pageNumber={index + 1} />
					))}{" "}
				</Document>
			</DocumentModal>
			{fetching && <Preloader text={"Fetching data"} />}
			{isApproved && <Success />}
		</div>
	);
};

export default Approval;
